import React from "react";
import WordPopup from "./WordPopup";
import { wordPopState } from "@stores/popup";
import { useAtomValue } from "jotai";

const WordPopupContainer = () => {
  const isActive = useAtomValue(wordPopState);
  return isActive.open && <WordPopup />;
};

export default React.memo(WordPopupContainer);
